import history from "../history"
import store from "../redux/store"



export const pushRoute = (route, maintainState) => {
  store.dispatch({ type: "SET_PATH", payload: route })
  if (maintainState) {
    history.push(route)
  } else {
    window.location = route
  }
}



// WEBPACK FOOTER //
// ./assets/common/route.js